/* eslint-disable arrow-body-style */
import React from 'react';
import { useEventSearchResultsStore } from '@src/routes/events/search/mothership/eventSearchResults.state';
import { ResultsStatus } from '@src/common/types';
import { ResultsSearching } from '../../../../../../common/FilterPanelPage/results/ResultsSearching';
import { ResultsError } from '../../../../../../common/FilterPanelPage/results/ResultsError';
import { EventItemDetailView } from './EventItemDetailView';
import { eventSearchId } from '../../../types';

export const EventItemDetailsDrawerContents = () => {
  const status = useEventSearchResultsStore((state) => state.eventDetailStatus);

  if (status === ResultsStatus.searching) {
    return <ResultsSearching id={eventSearchId} />;
  }

  if (status === ResultsStatus.error) {
    return <ResultsError id={eventSearchId} />;
  }

  if (status === ResultsStatus.results) {
    return <EventItemDetailView />;
  }

  return null;
};
